import angular from 'angular'
import './rewards.service'
import './edit/edit.controller'

angular
  .module('admin.rewards', ['admin.rewards.service', 'admin.rewards.edit'])
  .controller('RewardsCtrl', RewardsCtrl)

/** @ngInject */
function RewardsCtrl($state, $timeout, RewardsService) {
  var vm = this
  vm.Math = window.Math
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'n-asc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false
  vm.sortType3 = 'ts-p-desc'
  vm.sortReverse3 = false

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('rewards')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else if (tab === 'archived') {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#archived').addClass('active')
      $('#archivedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function() {
    $('#published').removeClass('active')
    $('#archived').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('rewards', 'draft')
  }

  vm.tabPublished = function() {
    $('#draft').removeClass('active')
    $('#archived').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('rewards', 'published')
  }

  vm.tabArchived = function() {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('rewards', 'archived')
  }

  var oldSortType, oldSortType2, oldSortType3
  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    RewardsService.listUnpublish(vm.oldPage, 25, vm.sortType).then(function(result) {
      var rewards = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p'] !== undefined) {
          rewards[i].isPub = true
          rewards[i]['ts-p'] = new Date(
            parseInt(
              rewards[i]['ts-p'].toString().substring(0, rewards[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          rewards[i].isPub = false
        }

        if (rewards[i].st === 0) {
          rewards[i].status = 'Draft'
        } else if (rewards[i].st === 1) {
          rewards[i].status = 'Published'
        }

        if (rewards[i].k === 0) {
          rewards[i].type = 'Coming Soon'
        } else if (rewards[i].k === 1) {
          rewards[i].type = 'Coins'
        } else if (rewards[i].k === 2) {
          rewards[i].type = 'Bundle Discount'
        } else if (rewards[i].k === 3) {
          rewards[i].type = 'Odds Boost'
        } else if (rewards[i].k === 4) {
          rewards[i].type = 'Award Bundle'
        } else if (rewards[i].k === 5) {
          rewards[i].type = 'Cash'
        } else if (rewards[i].k === 6) {
          rewards[i].type = 'Coupon'
        } else if (rewards[i].k === 7) {
          rewards[i].type = 'IRL (Swag / Physical)'
        }

        switch (rewards[i].l) {
          case 0:
            rewards[i].level = 'New'
            break
          case 1:
            rewards[i].level = 'Bronze'
            break
          case 2:
            rewards[i].level = 'Silver'
            break
          case 3:
            rewards[i].level = 'Gold'
            break
          case 4:
            rewards[i].level = 'Platinum'
            break
          case 5:
            rewards[i].level = 'Diamond'
            break
          case 6:
            rewards[i].level = 'Master'
            break
          case 7:
            rewards[i].level = 'Grandmaster'
            break
        }
        if (rewards[i].cat === 2) {
          rewards[i].level = ''
          rewards[i].tr = ''
        }
      }
      vm.sortType = oldSortType
      vm.itemsDraft = rewards
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    RewardsService.listPublish(vm.oldPage2, 25, vm.sortType2).then(function(result) {
      var rewards = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p']) {
          rewards[i].isPub = true
          rewards[i]['ts-p'] = new Date(
            parseInt(
              rewards[i]['ts-p'].toString().substring(0, rewards[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          rewards[i].isPub = false
        }

        if (rewards[i].st === 0) {
          rewards[i].status = 'Draft'
        } else if (rewards[i].st === 1) {
          rewards[i].status = 'Published'
        }

        if (rewards[i].k === 0) {
          rewards[i].type = 'Coming Soon'
        } else if (rewards[i].k === 1) {
          rewards[i].type = 'Coins'
        } else if (rewards[i].k === 2) {
          rewards[i].type = 'Bundle Discount'
        } else if (rewards[i].k === 3) {
          rewards[i].type = 'Odds Boost'
        } else if (rewards[i].k === 4) {
          rewards[i].type = 'Award Bundle'
        } else if (rewards[i].k === 5) {
          rewards[i].type = 'Cash'
        } else if (rewards[i].k === 6) {
          rewards[i].type = 'Coupon'
        } else if (rewards[i].k === 7) {
          rewards[i].type = 'IRL (Swag / Physical)'
        }

        switch (rewards[i].l) {
          case 0:
            rewards[i].level = 'New'
            break
          case 1:
            rewards[i].level = 'Bronze'
            break
          case 2:
            rewards[i].level = 'Silver'
            break
          case 3:
            rewards[i].level = 'Gold'
            break
          case 4:
            rewards[i].level = 'Platinum'
            break
          case 5:
            rewards[i].level = 'Diamond'
            break
          case 6:
            rewards[i].level = 'Master'
            break
          case 7:
            rewards[i].level = 'Grandmaster'
            break
        }
        if (rewards[i].cat === 2) {
          rewards[i].level = ''
          rewards[i].tr = ''
        }
      }
      vm.sortType2 = oldSortType2
      vm.itemsPublish = rewards
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage2 - 25
    } else {
      vm.first3 = false
    }

    oldSortType3 = angular.copy(vm.sortType3)
    RewardsService.listArchived(vm.oldPage3, 25, vm.sortType3).then(function(result) {
      var rewards = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p']) {
          rewards[i].isPub = true
          rewards[i]['ts-p'] = new Date(
            parseInt(
              rewards[i]['ts-p'].toString().substring(0, rewards[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          rewards[i].isPub = false
        }

        if (rewards[i].st === 0) {
          rewards[i].status = 'Draft'
        } else if (rewards[i].st === 1) {
          rewards[i].status = 'Published'
        }

        if (rewards[i].k === 0) {
          rewards[i].type = 'Coming Soon'
        } else if (rewards[i].k === 1) {
          rewards[i].type = 'Coins'
        } else if (rewards[i].k === 2) {
          rewards[i].type = 'Bundle Discount'
        } else if (rewards[i].k === 3) {
          rewards[i].type = 'Odds Boost'
        } else if (rewards[i].k === 4) {
          rewards[i].type = 'Award Bundle'
        } else if (rewards[i].k === 5) {
          rewards[i].type = 'Cash'
        } else if (rewards[i].k === 6) {
          rewards[i].type = 'Coupon'
        } else if (rewards[i].k === 7) {
          rewards[i].type = 'IRL (Swag / Physical)'
        }

        switch (rewards[i].l) {
          case 0:
            rewards[i].level = 'New'
            break
          case 1:
            rewards[i].level = 'Bronze'
            break
          case 2:
            rewards[i].level = 'Silver'
            break
          case 3:
            rewards[i].level = 'Gold'
            break
          case 4:
            rewards[i].level = 'Platinum'
            break
          case 5:
            rewards[i].level = 'Diamond'
            break
          case 6:
            rewards[i].level = 'Master'
            break
          case 7:
            rewards[i].level = 'Grandmaster'
            break
        }

        if (rewards[i].cat === 2) {
          rewards[i].level = ''
          rewards[i].tr = ''
        }
      }
      vm.sortType3 = oldSortType3
      vm.itemsArchived = rewards
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function(newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function(newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function() {
    $state.go('admin.rewards.edit', { id: 0 })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          RewardsService.remove(item.id).then(
            function() {
              if (vm.itemsDraft.length === 1 || vm.itemsDraft.length === 25) {
                $state.reload()
              } else {
                loadUnpublished(vm.pagination.current)
              }
              if (vm.itemsPublish.length === 1 || vm.itemsPublish.length === 25) {
                $state.reload()
              } else {
                loadPublished(vm.pagination2.current)
              }
              if (vm.itemsArchived.length === 1 || vm.itemsArchived.length === 25) {
                $state.reload()
              } else {
                loadArchived(vm.pagination3.current)
              }
            },
            function() {
              $timeout(function() {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function(item) {
    var date = parseInt(new Date().getTime() + '000')
    RewardsService.publish(item.id).then(function() {
      RewardsService.update(item.id, { 'ts-p': date }).then(function() {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        vm.sortType2 = 'ts-p-desc'
        vm.sortReverse2 = false
        vm.sortType3 = 'ts-p-desc'
        vm.sortReverse3 = false
        reloadPaginationDraft()
        reloadPaginationPublish()
        loadUnpublished(1)
        loadPublished(1)
      })
    })
  }

  vm.unpublish = function(item) {
    RewardsService.unpublish(item.id).then(function() {
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      vm.sortType2 = 'ts-p-desc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-p-desc'
      vm.sortReverse3 = false
      reloadPaginationDraft()
      reloadPaginationPublish()
      reloadPaginationArchived()
      loadUnpublished(1)
      loadPublished(1)
      loadArchived(1)
    })
  }

  vm.archived = function(item) {
    RewardsService.update(item.id, { st: 2 }).then(function() {
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      vm.sortType2 = 'ts-p-desc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-p-desc'
      vm.sortReverse3 = false
      reloadPaginationPublish()
      reloadPaginationArchived()
      loadPublished(1)
      loadArchived(1)
    })
  }

  vm.back = function() {
    loadUnpublished(1)
    loadPublished(1)
    loadArchived(1)
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 150,
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true
      var newIdx = parseInt(evt.newIndex) + 1
      RewardsService.reorder(evt.model.id, newIdx).then(function() {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        vm.sortType2 = 'n-asc'
        vm.sortReverse2 = false
        vm.sortType3 = 'n-asc'
        vm.sortReverse3 = false
        loadUnpublished()
        loadPublished()
        loadArchived()
        vm.disableTable = false
      })
    },
  }

  vm.sort = function(type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadUnpublished(vm.pagination.current)
    } else if (isTab === 2) {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    } else if (isTab === 3) {
      vm.sortReverse3 = !vm.sortReverse3
      if (vm.sortReverse3) {
        vm.sortType3 = type + '-asc'
      } else {
        vm.sortType3 = type + '-desc'
      }
      loadArchived(vm.pagination3.current)
    }
  }
}
